/**
 * Preset registry + resolution.
 *
 * Domain presets are tried in turn; the highest-confidence one above the threshold claims the dataset
 * and auto-builds its widgets. When none is confident, `resolvePreset` returns no preset and the UI
 * falls back to the generic column-mapper (see `generic.ts`).
 */
import { ParsedDataset } from '../parseDataset';
import { ImportPreset } from './types';
import { ciscoInventoryPreset } from './ciscoInventory';

export const PRESETS: ImportPreset[] = [ciscoInventoryPreset];

/** Minimum confidence for a preset to auto-claim a dataset. */
export const PRESET_DETECT_THRESHOLD = 0.2;

export interface PresetResolution {
  preset: ImportPreset | null;
  confidence: number;
}

export function resolvePreset(dataset: ParsedDataset): PresetResolution {
  let best: PresetResolution = { preset: null, confidence: 0 };
  for (const preset of PRESETS) {
    const confidence = preset.detect(dataset);
    if (confidence > best.confidence) best = { preset, confidence };
  }
  return best.confidence >= PRESET_DETECT_THRESHOLD ? best : { preset: null, confidence: 0 };
}

export * from './types';
